import React from "react";
import { injectIntl } from "react-intl";
import { material } from "react-native-typography";
import styled from "styled-components/native";
import { localize } from "cci-utility";
import Dialog from "../Dialog";
import { Container } from "../../layout/common";

const Text = styled.Text`
  ${material.body1Object}

  margin-top: 7px;
  color: ${props => props.theme.dialogFontColor || props.theme.fontColor};
`;

/**
 * Base dialog that shows the user a message along with some buttons on the bottom.
 * 
 * This can be used to make alert (Ok) and confirm (Yes/No) dialogs.
 * 
 * Props:
 * - message: Message to show the user, which can be a simple string or a react-intl object.
 * - children: Components to add along the bottom of the dialog, usually buttons like Ok or Yes / No.
 */
const MessageDialog = ({ intl, message, children, ...restProps }) => (
  <Dialog {...restProps} autoSnap={false}>
    {/* Message to show the user */}
    <Text>{localize(intl, message)}</Text>

    <Container flexDirection="row" justifyContent="center" margins="20px 0 0 0">
      {children}
    </Container>
  </Dialog>
);

export default injectIntl(MessageDialog);
